export default __webpack_public_path__ + "static/media/leaderboard-title.6a6953b9.png";